import { useCallback, useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Select, Tabs } from "antd";
import { useLocation, useNavigate } from "react-router";

import { ReactComponent as TitleIcon } from "../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import {
  accountListSelector,
  loanAccountListSelector,
  modeSelector,
  profileDetailsSelector,
} from "../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import SalaryAdvanceService from "../../services/salaryAdvance";
import AccountListItem from "../../components/account-list-item";
import AccountGridItem from "../../components/account-grid-item";
import SalaryAdvanceList from "../../components/salary-advance-list";
import SalaryAdvanceGrid from "../../components/salary-advance-grid";

export default function SalaryAdvance() {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const { t } = useTranslation();
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  const accountList = useSelector(accountListSelector);
  const account = accountList?.filter((ele) => ele.accountClass === "STAFSA");
  const [accDetails, setAccDetails] = useState(account[0] || "");
  const [selectedAccount, setSelectedAccount] = useState(
    accountList[0]?.accountNo || undefined
  );

  useEffect(() => {
    getsalaryAdvanceList(selectedAccount);
  }, []);

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  const getsalaryAdvanceList = useCallback(async (accountDet) => {
    try {
      const req = {
        accountNumber: accountDet,
      };
      const response = await SalaryAdvanceService.getsalaryAdvanceList(req);
      if (response.status === 200) {
        setDataSource(
          response.data["data"]["salaryAdvanceLoanQueryInfoListResponse"]
        );
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleAccountNo = (value) => {
    setSelectedAccount(value);
    const accountDet = accountList.find((ele) => ele.accountNo === value);
    setAccDetails(accountDet);
    getsalaryAdvanceList(accountDet.accountNo);
  };

  return (
    <>
        <div className=" d-flex align-items-center justify-content-between">
          {" "}
          <div >
            {/* <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <span onClick={() => navigate("/dashboard")}>
                  {t("navigation.home", {
                    defaultValue: "Home",
                  })}
                </span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>Salary Advance</span>
              </Breadcrumb.Item>
            </Breadcrumb> */}
          </div>
          <div className=" d-flex  my-1">
            <Button
              type="primary"
              size="large"
              className="primary-btn me-4"
              onClick={() => {
                navigate("/salaray-advance-request");
              }}
            >
              Loan Request
            </Button>
            <Button
            size="large"
              type="primary"
              className="primary-btn"
              onClick={() => {
                navigate("/salaray-advance-repay");
              }}
            >
              Loan Repay
            </Button>
          </div>
        </div>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="d-flex">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0 p-2">
              {" "}
              <h3 className="title mb-0">Salary Advance</h3>
            </h3>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end hide-xs">
            <label style={{ fontSize: "16px", padding: "5px" }}>
              {t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}{" "}
              :{" "}
            </label>
            <Select
              placeholder={t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}
              bordered={true}
              optionLabelProp={"value"}
              size="large"
              value={selectedAccount}
              onChange={(value) => handleAccountNo(value)}
              style={{ width: "37%", textAlign: "justify" }}
            >
              {accountList.map((account, index) => (
                <Select.Option key={index} value={account.accountNo}>
                  <span className="acc-short-name">
                    {account?.acctShortName}
                  </span>
                  <br />
                  <span style={{ fontSize: "12px" }}>{account?.accountNo}</span>
                  <br />
                  <span style={{ fontSize: "12px" }}>
                    {account?.branchName}
                  </span>
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </Card>{" "}
      <Card className="application-card mt-1" style={{ padding: "5px" }}>
        {showGridAccount === "GRID" && (
          <SalaryAdvanceGrid dataSource={dataSource} accDetails={accDetails} />
        )}
        {showGridAccount === "LIST" && (
          <SalaryAdvanceList dataSource={dataSource} accDetails={accDetails} />
        )}
      </Card>
    </>
  );
}
